var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FormFieldsApi } from '@ClientApi/formFields';
export const SET_CURRENCIES = 'SET_CURRENCIES';
export class SetCurrencies {
    constructor(currencies) {
        this.type = SET_CURRENCIES;
        this.payload = currencies;
    }
}
export const getCurrencies = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const fetchedCurrencies = yield FormFieldsApi.getCurrencies();
    dispatch(new SetCurrencies(fetchedCurrencies));
});
